import React from 'react'
import { motion } from "framer-motion"
import { Link } from 'react-router-dom'
import { zoomIn } from '../../utils/zoomIn'

const ContractCard = ({ id, src, contractType, description, social_media, url, style }) => {
  return (
    <motion.div className={`single-team-card ${style}`}
      initial="offscreen"
      whileInView="onscreen"
      variants={zoomIn(id)}
      viewport={{ once: true, amount: 0 }}
    >

      <div className="image">
        {url ? (
            <Link className="text-decoration-none" to={`/contract-template/${url}`}>
              <img src={src} alt="team-image" />
            </Link>
          ) : (
            <span style={{ color: 'gray', cursor: 'not-allowed' }}>
              <img src={src} style={{ opacity: '0.3'}} alt="team-image" />
            </span>
        )}
      </div>

      <h3>
        {url ? (
          <Link 
            className="text-decoration-none" 
            to={`/contract-template/${url}`}
          >
            {contractType}
          </Link>
        ) : (
          <span style={{ color: 'gray', cursor: 'not-allowed' }}>
            {contractType || 'Unavailable'}
          </span>
        )}
      </h3>

      <p>{description}</p>

      {/*
      <div className="social-list">
        <ul className="list-unstyled ps-0 mb-0">
          {
            social_media.map(({ id, icon, link }) => {
              return (
                <li key={id}>
                  <Link className="text-decoration-none" target="_blank" href={link}>
                    <i className={icon}></i>

                  </Link>
                </li>
              )
            })
          }
        </ul>
      </div>
      */}

    </motion.div>
  )
}

export default ContractCard;